/**
 * Tracks whether a clamped review comment overflows so the "read more" toggle only shows when needed.
 * Expects an `x-ref="commentText"` element.
 */
export default function reviewComment() {
    return {
        expanded: false,
        overflow: false,

        init() {
            this.$nextTick(() => {
                const element = this.$refs.commentText;

                if (element) {
                    this.overflow = element.scrollHeight > element.clientHeight + 2;
                }
            });
        },
    };
}
